<section class="section mt-60 grey-bg"
    [ngStyle]="{'background-image': sessionGroup?.congress?.config?.backg_form ?  'url(' + filesUrl + sessionGroup?.congress?.config?.backg_form+ ')':null }">
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-5">
        <div class="card shadow-sm p-4 text-center" style="max-width: 350px; width: 100%; border-radius: 1rem;">
            <div class="d-flex justify-content-center mb-4">
                <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
                    <span class="visually-hidden">{{'Loading'|translate}}</span>
                </div>
            </div>
            <h5 class="card-title mb-2">{{'LoadingData'|translate}}</h5>
            <p class="card-text text-muted">{{'PleaseWait'|translate}}</p>
        </div>
    </div>

    <div *ngIf="!isLoading" class="container mt-lg-3">
        <div class="card mb-3">
            <div class="card-body">
                <div class="row">
                    {{sessionGroup?.congress.name}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-12 d-lg-block d-none">
                <div class="sidebar sticky-bar p-4 rounded shadow white-bg">
                    <div class="widget">
                        <h5 class="widget-title">{{'QuestionStatistics'|translate}} :</h5>
                        <div class="row mt-4">
                            <div class="col-6 text-center">
                                <h5 class="mb-0">{{ activeParticipantCount }}</h5>
                                <p class="text-muted mb-0">{{'ParticipantsActifs'|translate}} </p>
                            </div>
                            <div class="col-6 text-center">
                                <h5 class="mb-0">{{ totalQuestionsCount }}</h5>
                                <p class="text-muted mb-0">{{'QuestionsAsked'|translate}} </p>
                            </div>
                        </div>
                    </div>
                    <div class="widget mt-4 pt-2">
                        <h5 class="widget-title">{{'Questions'|translate}} :</h5>
                        <div class="progress-box mt-4">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <h6 class="title text-muted mb-0">{{'QuestionsRead'|translate}}</h6>
                                <span class="text-muted h6 mb-0">
                                    {{ getCurrentPageQuestions().length }} / {{
                                    getFormattedFilteredQuestions('allQuestion').length }}
                                </span>
                            </div>

                            <div class="progress">
                                <div class="progress-bar bg-primary" [style.width.%]="getProgressPercentage()"></div>
                            </div>
                        </div>
                    </div>

                    <ul class="list-unstyled sidebar-nav mb-0 mt-4" id="navmenu-nav">
                        <h4 class="widget-title">{{'Conferences'|translate}} :</h4>
                        <li class="form-check mb-2" *ngFor="let accessName of getAllAccessNames()">
                            <input class="form-check-input" type="checkbox" [id]="'access-' + accessName"
                                [value]="accessName" (change)="toggleAccessNameSelection($event)" />
                            <label class="form-check-label ms-2" [for]="'access-' + accessName">
                                {{ accessName }}
                            </label>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-8 col-12 name-session">


                <div class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 white-bg py-3">
                                <div class="tooltip-container d-flex align-items-center gap-2">
                                    <strong class="mb-0">{{ sessionGroup?.name }}</strong>
                                    <button (click)="toggleTable()" class="btn btn-sm btn-light p-1">
                                        <i [ngClass]="isTableVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                                    </button>
                                </div>

                                <div *ngIf="isTableVisible"
                                    class="custom-tooltip mt-3 shadow rounded bg-white p-3 table-margin-bottom"
                                    style="max-height: 200px; overflow-y: auto; z-index: 10; position: relative;">
                                    <table class="table table-hover mb-0 table-responsive">
                                        <thead class="bg-light" style="position: sticky; top: 0; z-index: 1;">
                                            <tr>
                                                <th class="text-primary fw-semibold border-0">
                                                    {{ 'HOME.SURNAME' | translate }}
                                                </th>
                                                <th class="text-primary fw-semibold border-0">
                                                    {{ 'CreationDate' | translate }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let access of sessionGroup?.accesses">
                                                <td class="border-0 text-wrap">{{ access.name }}</td>
                                                <td class="border-0 text-muted small">
                                                    {{ displayDate(access.created_at) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card responsive-margin">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 white-bg">
                                <div class="row mb-3 justify-content-between align-items-center">
                                    <div class="col-auto d-flex align-items-center gap-2">
                                        <label for="itemsPerPage" class="mb-0">{{ 'Show' | translate }}:</label>
                                        <div class="select-container">
                                            <select id="itemsPerPage" [(ngModel)]="itemsPerPage"
                                                (change)="onItemsPerPageChange(itemsPerPage)"
                                                class="form-select form-select-sm compact-select">
                                                <option *ngFor="let option of itemsPerPageOptions" [value]="option">
                                                    {{ option === -1 ? ('All' | translate) : option }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-auto mt-3">
                                        <div class="input-group input-group-sm" style="width: 250px;">
                                            <div class="position-relative" style="width: 250px;">
                                                <input type="text" class="form-control pe-5" placeholder="Rechercher..."
                                                    [(ngModel)]="searchTerm" (input)="applyFilter()" />
                                                <i class="fas fa-search search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tabs -->
                                <ul class="nav nav-pills nav-justified flex-column flex-sm-row rounded mt-2"
                                    id="pills-tab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link rounded active" id="pills-cloud-tab" data-bs-toggle="pill"
                                            href="#pills-cloud" role="tab" aria-controls="pills-cloud"
                                            aria-selected="false">
                                            <div class="text-center py-2">
                                                <h6 class="mb-0">{{'All'|translate}}</h6>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link rounded" id="pills-smart-tab" data-bs-toggle="pill"
                                            href="#pills-smart" role="tab" aria-controls="pills-smart"
                                            aria-selected="false">
                                            <div class="text-center py-2">
                                                <h6 class="mb-0">{{'Read'|translate}}</h6>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link rounded" id="pills-apps-tab" data-bs-toggle="pill"
                                            href="#pills-apps" role="tab" aria-controls="pills-apps"
                                            aria-selected="false">
                                            <div class="text-center py-2">
                                                <h6 class="mb-0">{{'Unread'|translate}}</h6>
                                            </div>
                                        </a>
                                    </li>
                                </ul>

                                <div class="row pt-3">
                                    <div class="col-12">
                                        <div class="tab-content" id="pills-tabContent">
                                            <!-- ALL -->
                                            <div class="tab-pane fade show active" id="pills-cloud" role="tabpanel"
                                                aria-labelledby="pills-cloud-tab">
                                                <div
                                                    *ngFor="let row of getPaginatedQuestions('allQuestion'); trackBy: trackByFn">
                                                    <app-question-row [row]="row" [showChecked]="true"
                                                        (visibilityChange)="updatedVisibilityChange($event.row, $event.checked)"
                                                        [totalQuestionsCount]="totalQuestionsCount">
                                                    </app-question-row>
                                                </div>
                                                <nav>
                                                    <ul class="pagination justify-content-center">
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('allQuestion') === 1">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('allQuestion', currentPage('allQuestion') - 1, $event)">
                                                                {{ 'Previous' | translate }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            *ngFor="let page of [].constructor(totalPages('allQuestion')); let i = index"
                                                            [class.active]="i + 1 === currentPage('allQuestion')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('allQuestion', i + 1, $event)">
                                                                {{ i + 1 }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('allQuestion') === totalPages('allQuestion')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('allQuestion', currentPage('allQuestion') + 1, $event)">
                                                                {{ 'Next' | translate }}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>

                                            <div class="tab-pane fade" id="pills-smart" role="tabpanel"
                                                aria-labelledby="pills-smart-tab">
                                                <div *ngFor="let row of getPaginatedVisible()">
                                                    <app-question-row [row]="row" [showChecked]="true"
                                                        (visibilityChange)="updatedVisibilityChange($event.row, $event.checked)">
                                                    </app-question-row>
                                                </div>
                                                <nav class="mt-4">
                                                    <ul class="pagination justify-content-center">
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('readed') === 1">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('readed', currentPage('readed') - 1, $event)">
                                                                {{ 'Previous' | translate }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            *ngFor="let page of [].constructor(totalPages('readed')); let i = index"
                                                            [class.active]="i + 1 === currentPage('readed')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('readed', i + 1, $event)">
                                                                {{ i + 1 }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('readed') === totalPages('readed')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('readed', currentPage('readed') + 1, $event)">
                                                                {{ 'Next' | translate }}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>

                                            <div class="tab-pane fade" id="pills-apps" role="tabpanel"
                                                aria-labelledby="pills-apps-tab">
                                                <div *ngFor="let row of getPaginatedNotVisible()">
                                                    <app-question-row [row]="row" [showChecked]="false"
                                                        (visibilityChange)="updatedVisibilityChange($event.row, $event.checked)">
                                                    </app-question-row>
                                                </div>
                                                <nav class="mt-4">
                                                    <ul class="pagination justify-content-center">
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('unreaded') === 1">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('unreaded', currentPage('unreaded') - 1, $event)">
                                                                {{ 'Previous' | translate }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            *ngFor="let page of [].constructor(totalPages('unreaded')); let i = index"
                                                            [class.active]="i + 1 === currentPage('unreaded')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('unreaded', i + 1, $event)">
                                                                {{ i + 1 }}
                                                            </a>
                                                        </li>
                                                        <li class="page-item"
                                                            [class.disabled]="currentPage('unreaded') === totalPages('unreaded')">
                                                            <a class="page-link" href="#"
                                                                (click)="goToPage('unreaded', currentPage('unreaded') + 1, $event)">
                                                                {{ 'Next' | translate }}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>